// pt — checkin/quickCheck/stepTracker blocks translated.
export const pt = {
  "common": {
    "loading": "A carregar…",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "edit": "Editar",
    "close": "Fechar",
    "confirm": "Confirmar",
    "back": "Voltar",
    "next": "Próximo",
    "submit": "Enviar",
    "search": "Pesquisar",
    "select": "Selecionar",
    "or": "Ou",
    "and": "e",
    "note": "Nota",
    "viewAll": "Ver tudo",
    "learnMore": "Saber mais",
    "getStarted": "Começar",
    "continue": "Continuar",
    "saving": "A guardar…"
  },
  "nav": {
    "dashboard": "Painel",
    "nutrition": "Nutrição inteligente",
    "family": "Família",
    "checkIn": "Registo diário",
    "insights": "Insights",
    "trends": "Tendências",
    "habits": "Hábitos",
    "medications": "Medicamentos",
    "expertSupport": "Suporte Especializado",
    "profile": "Perfil",
    "healthHub": "Centro de Saúde",
    "support": "Ajuda e apoio",
    "wellness": "Bem-estar",
    "education": "Educação",
    "community": "Comunidade",
    "preventiveHealth": "Saúde Preventiva",
    "womensHealth": "Saúde da Mulher",
    "reminders": "Lembretes de Saúde",
    "meals": "Refeições",
    "orders": "Pedidos",
    "subscription": "Assinatura",
    "logout": "Sair"
  },

  "navShort": {
    "dashboard": "Início",
    "nutrition": "Nutrição",
    "family": "Família",
    "care": "Serviços",
    "support": "Ajuda",
    "profile": "Perfil"
  },
  "auth": {
    "login": "Entrar",
    "register": "Criar conta",
    "logout": "Sair",
    "email": "E-mail",
    "password": "Palavra-passe",
    "name": "Nome Completo",
    "forgotPassword": "Esqueceu a senha?",
    "noAccount": "Ainda não tem conta?",
    "haveAccount": "Já tem uma conta?",
    "signInHere": "Entre aqui",
    "signUpHere": "Cadastre-se aqui",
    "welcomeBack": "Bem-vindo de volta!",
    "getStarted": "Vamos começar",
    "biometricLogin": "Entrar com Biometria",
    "biometricHelper": "Use impressão digital, Face ID ou Windows Hello",
    "vendorLogin": "Login de Fornecedor",
    "createOne": "Criar conta",
    "tagline": "Cuide da sua saúde — um simples registo por dia.",
    "takes30s": "Menos de 30 segundos",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "Enter your password",
    "checking": "Checking…",
    "continue": "Continuar",
    "secureMessage": "Secure and private — your data stays protected",
    "biometricSoon": "Biometric login — Coming Soon",
    "showPassword": "Exibir senha",
    "hidePassword": "Ocultar senha",
    "vendor": {
      "title": "Login de Parceiro Comercial",
      "subtitle": "Acesse seu painel de parceiro HealthLoop",
      "businessEmail": "E-mail comercial",
      "emailPlaceholder": "parceiro@empresa.com.br",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Entrando...",
      "signIn": "Entrar",
      "notVendorYet": "Ainda não é um parceiro comercial?",
      "registerBusiness": "Cadastre sua empresa",
      "areYouUser": "Você é um usuário?",
      "userLogin": "Login de Usuário",
      "welcomeBackToast": "Bem-vindo(a) de volta!",
      "genericError": "Falha no login. Por favor, tente novamente."
    },
    "admin": {
      "backToUserLogin": "Login de usuário",
      "title": "Acesso Administrativo",
      "restrictedBadge": "Restrito",
      "tagline": "Console do operador HealthLoop — credenciais de administrador necessárias.",
      "emailLabel": "E-mail do administrador",
      "emailPlaceholder": "admin@seudominio.com",
      "passwordLabel": "Senha",
      "passwordPlaceholder": "Digite sua senha de administrador",
      "signingIn": "Entrando...",
      "submit": "Entrar no console admin",
      "secureNote": "Conexão segura · sessão criptografada",
      "restrictedTitle": "Esta área é restrita a administradores.",
      "restrictedBody": "Sua conta está conectada, mas não possui acesso administrativo. Saia para tentar outra conta ou retorne ao aplicativo principal.",
      "signOut": "Sair",
      "backToApp": "Voltar para o app"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Como você está se sentindo hoje?",
      "subtitle": "Check-in rápido — leva menos de 60 segundos"
    },
    "section1": {
      "title": "O que você está notando hoje?",
      "hint": "(Selecione tudo o que se aplica)"
    },
    "environment": {
      "title": "Seu ambiente hoje",
      "hint": "Ajude-nos a entender o que está ao seu redor"
    },
    "basicChecks": {
      "title": "Verificações rápidas",
      "hint": "Opcional, mas ajuda muito"
    },
    "validation": {
      "pickOne": "Por favor, responda pelo menos uma pergunta"
    },
    "submit": {
      "cta": "Ver Meus Insights de Bem-estar",
      "saving": "Salvando...",
      "analyzing": "Analisando seus padrões de saúde...",
      "savedToast": "✅ Check-in salvo! Analisando seus padrões de saúde..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Contador de Passos",
      "subtitle": "Acompanhamento de atividade honesto e local",
      "backToDashboard": "Voltar para o painel"
    },
    "today": {
      "title": "Passos de hoje",
      "goalProgress": "{{current}} / {{goal}} passos",
      "goalReached": "Meta alcançada — bom trabalho!",
      "keepGoing": "Continue assim — você está no caminho certo."
    },
    "streak": {
      "label": "Sequência atual",
      "days": "{{count}} dia",
      "daysPlural": "{{count}} dias"
    },
    "badges": {
      "title": "Conquistas",
      "empty": "Você ganhará insígnias conforme cria o hábito."
    },
    "reminders": {
      "title": "Incentivos de movimento",
      "hint": "Lembretes gentis para caminhar um pouco se estiver sentado por muito tempo.",
      "enabled": "Ativado",
      "disabled": "Desativado"
    },
    "insights": {
      "weeklyAverage": "Média semanal",
      "weeklyGoal": "Meta semanal"
    },
    "actions": {
      "connect": "Conectar fonte de passos",
      "manualLog": "Registrar passos manualmente",
      "changeGoal": "Alterar meta diária"
    }
  },
  "checkin": {
    "header": {
      "title": "Check-in Diário de Saúde",
      "subtitle": "Leva menos de 60 segundos",
      "restDayLink": "Não estou com disposição hoje"
    },
    "snapshot": {
      "title": "Seu painel, atualizado",
      "healthScore": "Pontuação de saúde",
      "todayTasks": "Tarefas de hoje",
      "dayStreak": "dias seguidos"
    },
    "resume": {
      "banner": "Você parou por aqui",
      "startFresh": "Recomeçar",
      "dismiss": "Fechar"
    },
    "progress": {
      "allSet": "Tudo pronto",
      "step": "Passo {{current}} de {{total}}",
      "ariaLabel": "Progresso do check-in diário: {{done}} de {{total}} seções concluídas"
    },
    "insights": {
      "title": "Suas Análises de Bem-estar",
      "subtitle": "Personalizadas para você hoje",
      "insightForYou": "Dica para você",
      "simpleActions": "Ações simples que você pode tomar",
      "whenToSeekHelp": "Quando buscar ajuda",
      "nhsAdvice": "Se estiver preocupado, entre em contato com seu médico de confiança",
      "backToDashboard": "Voltar para o Painel",
      "newCheckIn": "Novo Check-In",
      "disclaimer": "O HealthLoop oferece orientações de bem-estar, não diagnósticos."
    },
    "restDay": {
      "title": "Descansar faz parte do ritmo.",
      "body": "Estaremos aqui amanhã, quando você estiver pronto.",
      "streakNote": "Sua sequência não mudou — ela também está apenas descansando.",
      "backToDashboard": "Voltar para o painel",
      "changedMind": "Na verdade, eu gostaria de fazer o check-in."
    },
    "feelings": {
      "title": "Como você está se sentindo hoje?",
      "hint": "Selecione tudo o que se aplica",
      "tired": "Me sentindo cansado(a)",
      "headache": "Dor de cabeça",
      "stressed": "Estressado(a) ou sobrecarregado(a)",
      "pain": "Dores no corpo ou desconforto",
      "okay": "Estou me sentindo bem hoje"
    },
    "basics": {
      "title": "O essencial",
      "sleepQ": "Você dormiu bem a noite passada?",
      "waterQ": "Você bebeu água suficiente hoje?",
      "foodQ": "Você se alimentou bem hoje?",
      "activityQ": "Quão ativo(a) você foi hoje?",
      "yes": "Sim",
      "notReally": "Não muito",
      "notYet": "Ainda não",
      "notActive": "Não fui ativo(a)",
      "lightActivity": "Atividade leve",
      "active": "Ativo(a)"
    },
    "mind": {
      "title": "Mente e energia",
      "stressQ": "Como está seu nível de estresse hoje?",
      "moodQ": "Como está seu humor hoje?",
      "energyQ": "Como está seu nível de energia hoje?",
      "low": "Baixo",
      "moderate": "Moderado",
      "high": "Alto",
      "neutral": "Neutro",
      "good": "Bom",
      "okay": "Ok"
    },
    "day": {
      "title": "Seu dia",
      "routineQ": "Você seguiu sua rotina normal hoje?",
      "yes": "Sim",
      "no": "Não"
    },
    "environment": {
      "title": "Seu ambiente hoje",
      "describeQ": "Como você descreveria o ambiente ao seu redor?",
      "comfortable": "😊 Confortável",
      "slightlyUncomfortable": "😐 Um pouco desconfortável",
      "challenging": "😓 Desafiador",
      "affectedQ": "O ambiente afetou como você se sente?",
      "yes": "Sim",
      "no": "Não",
      "exposureLabel": "Exposição (selecione tudo o que se aplica)",
      "heat": "🌡️ Calor",
      "cold": "❄️ Frio",
      "noise": "🔊 Ruído",
      "dustSmoke": "💨 Poeira ou fumaça",
      "crowded": "👥 Lugar lotado",
      "none": "✅ Nenhuma"
    },
    "submit": {
      "analyzing": "Analisando seus padrões de saúde...",
      "cta": "Ver Minhas Análises"
    },
    "toast": {
      "savedFull": "Check-in salvo! Seu painel foi atualizado.",
      "savedShort": "Check-in salvo."
    }
  },
  "onboarding": {
    "welcome": "Welcome",
    "completeSetup": "Complete Setup",
    "stepProgress": "Step {{step}} of {{total}}",
    "percentComplete": "{{percent}}% complete",
    "welcomeToast": "Welcome to HealthLoop! Your profile is set up.",
    "errorAgeRange": "Please select your age range",
    "errorCountry": "Please select your country",
    "errorGoal": "Please select your primary health goal",
    "errorCuisine": "Please select at least one cuisine preference",
    "errorGeneric": "Failed to complete onboarding. Please try again.",
    "step1Title": "Welcome to HealthLoop! 👋",
    "step1Subtitle": "Let's personalize your health journey",
    "ageRangeLabel": "What's your age range?",
    "genderLabel": "Gender (Optional)",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_non-binary": "Non-binary",
    "gender_prefer_not_to_say": "Prefer not to say",
    "step2Title": "Where are you based? 🌍",
    "step2Subtitle": "This helps us recommend culturally relevant meals",
    "countryLabel": "Select your country",
    "country_uk": "United Kingdom",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "South Africa",
    "country_usa": "United States",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Other",
    "step3Title": "What's your main goal? 🎯",
    "step3Subtitle": "Choose your primary health objective",
    "additionalGoals": "Any other goals? (Optional)",
    "goal_weight_loss": "Weight Loss",
    "goalDesc_weight_loss": "Lose weight healthily",
    "goal_weight_maintenance": "Maintain Weight",
    "goalDesc_weight_maintenance": "Stay at current weight",
    "goal_muscle_gain": "Build Muscle",
    "goalDesc_muscle_gain": "Gain strength & muscle",
    "goal_general_wellness": "General Wellness",
    "goalDesc_general_wellness": "Overall health improvement",
    "goal_better_sleep": "Better Sleep",
    "goalDesc_better_sleep": "Improve sleep quality",
    "goal_reduce_stress": "Reduce Stress",
    "goalDesc_reduce_stress": "Manage stress better",
    "goal_increase_energy": "More Energy",
    "goalDesc_increase_energy": "Feel more energized",
    "step4Title": "Food preferences 🍽️",
    "step4Subtitle": "Select cuisines you enjoy and any dietary restrictions",
    "cuisineLabel": "Preferred Cuisines",
    "cuisineHint": "Select at least one (you can choose multiple)",
    "dietaryLabel": "Dietary Restrictions (Optional)",
    "diet_vegetarian": "Vegetarian",
    "diet_vegan": "Vegan",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Gluten-Free",
    "diet_dairy_free": "Dairy-Free",
    "diet_pescatarian": "Pescatarian",
    "step5Title": "Health conditions 🏥",
    "step5Subtitle": "Optional — helps us provide better recommendations",
    "conditionsLabel": "Do you have any of these conditions?",
    "conditionsHint": "This information is private and helps personalize your experience",
    "condition_diabetes": "Diabetes",
    "condition_hypertension": "High Blood Pressure",
    "condition_heart_disease": "Heart Disease",
    "condition_thyroid": "Thyroid Issues",
    "condition_celiac": "Celiac Disease",
    "condition_ibs": "IBS",
    "condition_none": "None",
    "privacyTitle": "Your data is protected",
    "privacyBody": "Your personal information is encrypted and stored securely. We use this data only to personalise your experience with tailored meal recommendations, health tips, and notifications. Your data will never be shared with third parties without your explicit consent.",
    "trackMedication": "I want to track my medications",
    "specialistInterest": "I'm interested in specialist consultations",
    "welcomeTitle": "Bem-vindo ao HealthLoop! 👋",
    "welcomeSubtitle": "Vamos personalizar sua inteligência de bem-estar e saúde preventiva em apenas alguns passos",
    "stepLabel": "Passo {{current}} de {{total}}",
    "skipForNow": "Pular por enquanto",
    "skipToast": "Você pode completar o cadastro quando quiser pelo seu perfil",
    "back": "Voltar",
    "next": "Próximo",
    "completing": "Finalizando...",
    "complete": "Concluir Configuração",
    "successToast": "Bem-vindo ao HealthLoop! Seu perfil já está personalizado 🎉",
    "failureToast": "Não foi possível concluir o cadastro",
    "validation": {
      "basicInfo": "Por favor, preencha todas as informações básicas",
      "pickGoal": "Por favor, selecione ao menos uma meta de saúde",
      "pickPrimary": "Por favor, selecione sua meta principal",
      "pickRegion": "Por favor, selecione sua região cultural para sugestões de refeições",
      "pickFocus": "Por favor, selecione seu foco principal em bem-estar"
    },
    "step1": {
      "title": "Seu Perfil de Saúde",
      "description": "Ajude-nos a construir sua inteligência de saúde personalizada",
      "age": "Idade *",
      "agePlaceholder": "ex: 30",
      "height": "Altura (cm) *",
      "heightPlaceholder": "ex: 170",
      "weight": "Peso (kg) *",
      "weightPlaceholder": "ex: 70"
    },
    "step2": {
      "title": "Suas Metas de Saúde",
      "description": "Selecione todas que desejar e depois escolha sua meta principal",
      "primaryLabel": "Selecione Sua Meta Principal *",
      "primaryBadge": "Principal"
    },
    "step3": {
      "title": "🌍 Cultura e Preferências Alimentares",
      "description": "Ajude-nos a personalizar suas recomendações de refeições",
      "regionLabel": "Região Cultural *",
      "regionHint": "Escolha sua origem cultural para receber sugestões de pratos personalizados",
      "countryLabel": "País (Opcional)",
      "countryPlaceholder": "ex: Nigéria, Quênia, Jamaica",
      "countryHint": "Para recomendações ainda mais assertivas",
      "foodPrefLabel": "Preferência de Diversidade Alimentar"
    },
    "step4": {
      "title": "Foco Principal em Bem-estar",
      "description": "Escolha a área em que você mais deseja focar"
    },
    "step5": {
      "title": "Suas Preferências",
      "description": "Personalize sua experiência no HealthLoop",
      "trackMeds": "Acompanhar Medicamentos",
      "trackMedsHint": "Ative o registro e lembretes de medicamentos no seu acompanhamento diário",
      "specialist": "Interesse em Suporte Especializado",
      "specialistHint": "Tenha acesso a especialistas em bem-estar, nutricionistas e profissionais de saúde mental",
      "confidentialTitle": "Suporte Confidencial:",
      "confidentialBody": "Todas as suas informações são protegidas e usadas exclusivamente para fornecer insights de saúde preventiva."
    },
    "step6": {
      "title": "Personalização de Refeições",
      "description": "Ajude-nos a recomendar pratos que combinem com seu gosto e necessidades",
      "cuisinesLabel": "Culinárias Favoritas (Opcional)",
      "cuisinesHint": "Selecione os tipos de culinária que você mais gosta",
      "dietaryLabel": "Restrições Alimentares (Opcional)",
      "dietaryHint": "Selecione as que se aplicam a você",
      "allergiesLabel": "Alergias Comuns (Opcional)",
      "allergiesHint": "Selecione se possuir alguma alergia alimentar",
      "personalisedTitle": "Refeições Personalizadas:",
      "personalisedBody": "Usaremos essas preferências para sugerir refeições ideais para você. Você pode mudar isso depois nas Configurações."
    },
    "healthGoals": {
      "better_sleep": "Dormir Melhor",
      "reduce_stress": "Reduzir Estresse",
      "increase_energy": "Mais Energia",
      "weight_management": "Gestão de Peso",
      "improve_fitness": "Melhorar Condicionamento",
      "better_nutrition": "Melhor Nutrição",
      "mental_wellness": "Bem-estar Mental",
      "chronic_condition": "Cuidado Preventivo"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Saúde Mental",
        "description": "Foco no humor, estresse e bem-estar emocional"
      },
      "physical_fitness": {
        "label": "Forma Física",
        "description": "Foco em exercícios, força e atividades"
      },
      "nutrition": {
        "label": "Nutrição",
        "description": "Foco em dieta, refeições e alimentação saudável"
      },
      "sleep": {
        "label": "Qualidade do Sono",
        "description": "Foco no descanso, padrões de sono e recuperação"
      },
      "stress_management": {
        "label": "Gestão de Estresse",
        "description": "Foco em relaxamento e redução de tensões"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Oeste Africana",
        "description": "Culinária nigeriana, ganesa e senegalesa"
      },
      "east_african": {
        "label": "Leste Africana",
        "description": "Culinária queniana, etíope e tanzaniana"
      },
      "north_african": {
        "label": "Norte Africana",
        "description": "Culinária marroquina e egípcia"
      },
      "southern_african": {
        "label": "Sul Africana",
        "description": "Culinária sul-africana"
      },
      "caribbean": {
        "label": "Caribenha",
        "description": "Culinária jamaicana, trinitária e barbadiana"
      },
      "middle_eastern": {
        "label": "Oriente Médio",
        "description": "Culinária libanesa, palestina e síria"
      },
      "south_asian": {
        "label": "Sul Asiática",
        "description": "Culinária indiana, paquistanesa e bengalesa"
      },
      "east_asian": {
        "label": "Leste Asiática",
        "description": "Culinária chinesa, japonesa e coreana"
      },
      "southeast_asian": {
        "label": "Sudeste Asiático",
        "description": "Culinária tailandesa, vietnamita e indonésia"
      },
      "western": {
        "label": "Ocidental",
        "description": "Culinária americana e europeia"
      },
      "latin_american": {
        "label": "Latino-Americana",
        "description": "Culinária mexicana, brasileira e argentina"
      },
      "mediterranean": {
        "label": "Mediterrânea",
        "description": "Culinária grega, italiana e espanhola"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Tradicional",
        "description": "Principalmente pratos da sua região cultural"
      },
      "mixed": {
        "label": "Mista",
        "description": "Equilíbrio entre culinária local e internacional"
      },
      "international": {
        "label": "Internacional",
        "description": "Diversas culinárias globais"
      }
    },
    "cuisines": {
      "west_african": "Oeste Africana",
      "caribbean": "Caribenha",
      "mediterranean": "Mediterrânea",
      "asian": "Asiática",
      "western": "Ocidental",
      "indian": "Indiana",
      "middle_eastern": "Oriente Médio",
      "general": "Todas as Culinárias"
    },
    "dietary": {
      "vegetarian": "Vegetariana",
      "vegan": "Vegana",
      "pescatarian": "Pescetariana",
      "gluten_free": "Sem Glúten",
      "dairy_free": "Sem Laticínios",
      "low_carb": "Baixo Carboidrato"
    },
    "allergies": {
      "nuts": "Castanhas/Nozes",
      "shellfish": "Frutos do Mar",
      "dairy": "Laticínios",
      "eggs": "Ovos",
      "soy": "Soja",
      "gluten": "Glúten"
    },
    "cuisine_nigerian": "Nigeriana",
    "cuisine_ghanaian": "Ganesa",
    "cuisine_senegalese": "Senegalesa",
    "cuisine_kenyan": "Queniana",
    "cuisine_ethiopian": "Etíope",
    "cuisine_moroccan": "Marroquina",
    "cuisine_south_african": "Sul-africana",
    "cuisine_jamaican": "Jamaicana",
    "cuisine_trinidadian": "Trinitária",
    "cuisine_lebanese": "Libanesa",
    "cuisine_turkish": "Turca",
    "cuisine_greek": "Grega",
    "cuisine_italian": "Italiana",
    "cuisine_french": "Francesa",
    "cuisine_british": "Britânica",
    "cuisine_indian_south": "Sul-indiana",
    "cuisine_indian_north": "Norte-indiana",
    "cuisine_pakistani": "Paquistanesa",
    "cuisine_japanese": "Japonesa",
    "cuisine_chinese": "Chinesa",
    "cuisine_korean": "Coreana",
    "cuisine_vietnamese": "Vietnamita",
    "cuisine_thai": "Tailandesa",
    "cuisine_filipino": "Filipina",
    "cuisine_american": "Americana",
    "cuisine_mexican": "Mexicana",
    "cuisine_brazilian": "Brasileira",
    "cuisine_peruvian": "Peruana"
  },
  "dashboard": {
    "welcome": "Bem-vindo de volta",
    "greeting": "Olá",
    "goodMorning": "Bom dia",
    "goodAfternoon": "Boa tarde",
    "goodEvening": "Boa noite",
    "tagline": "Pequenos passos saudáveis criam mudanças duradouras",
    "microcopy": "Your wellness journey matters.",
    "welcomeSubtitleMorning1": "A calm start to the day.",
    "welcomeSubtitleMorning2": "Glad you stopped by this morning.",
    "welcomeSubtitleMorning3": "Small moments add up.",
    "welcomeSubtitleAfternoon1": "Hope your day feels steady.",
    "welcomeSubtitleAfternoon2": "Welcome back to HealthLoop.",
    "welcomeSubtitleAfternoon3": "Take a breath — you're doing well.",
    "welcomeSubtitleEvening1": "Winding down with you.",
    "welcomeSubtitleEvening2": "A gentle close to the day.",
    "welcomeSubtitleEvening3": "Welcome back this evening.",
    "title": "Sua Plataforma de Inteligência em Saúde Preventiva",
    "subtitle": "Rastreie, aprenda e aja antes que os problemas escalem",
    "summary": "Seu Resumo de Inteligência em Saúde",
    "summaryDesc": "Insights em tempo real sobre prevenção, educação, engajamento e bem-estar",
    "comprehensiveSupport": "Suporte abrangente em prevenção, educação, engajamento e bem-estar",
    "todayCheckIn": "Registo de hoje",
    "quickActions": "Ações rápidas",
    "healthOverview": "Visão Geral da Saúde",
    "recentActivity": "Atividade Recente",
    "viewAll": "Ver tudo",
    "preventiveHealth": "Saúde Preventiva",
    "preventiveHealthDesc": "Rastreamento diário, monitoramento de bem-estar e alertas preventivos",
    "education": "Educação",
    "educationDesc": "Insights baseados em evidências, artigos de saúde e orientação especializada",
    "engagement": "Engajamento",
    "engagementDesc": "Desafios comunitários, rastreamento de hábitos e apoio social",
    "wellness": "Bem-Estar",
    "wellnessDesc": "Nutrição inteligente, equilíbrio de estilo de vida e bem-estar holístico",
    "todaysInsight": "Insight de Hoje",
    "wellnessScore": "Pontuação de Bem-Estar",
    "healthStreak": "Sequência de Saúde",
    "days": "dias",
    "logHealth": "Registrar Saúde",
    "getEducated": "Educar-se",
    "communityChallenge": "Desafio Comunitário",
    "checkWellness": "Verificar Bem-Estar",
    "verified": "Verificado",
    "joinCommunity": "Junte-se à Comunidade",
    "personalizedPlan": "Plano Personalizado",
    "score": "Pontuação",
    "checkIns": "check-ins",
    "habits": "hábitos",
    "preventive": "Preventivo",
    "healthMetrics": "Métricas de Saúde",
    "trackMetrics": "Rastrear Métricas",
    "startTracking": "Começar a rastrear",
    "logMetrics": "Registrar Métricas",
    "dailyInsight": "Insight Diário",
    "learnAbout": "Aprenda sobre saúde preventiva hoje",
    "articlesAvailable": "artigos disponíveis",
    "browseArticles": "Navegar Artigos",
    "currentStreak": "Sequência Atual",
    "keepGoing": "Continue assim!",
    "startStreak": "Comece sua sequência",
    "checkIn": "Check-In",
    "nutritionPlan": "Plano de Nutrição",
    "mealsPlanned": "refeições planejadas",
    "viewPlan": "Ver Plano",
    "planYourWeek": "Planeje sua semana",
    "moodStress": "Humor e Estresse",
    "howFeeling": "Como você está se sentindo?",
    "logWellness": "Registrar Bem-Estar",
    "medications": "Medicamentos",
    "noMeds": "Nenhum medicamento rastreado",
    "addMedications": "Adicionar medicamentos",
    "daysTracked": "Dias Rastreados",
    "noHabits": "Nenhum hábito ainda",
    "startTrackingHabits": "Começar a rastrear hábitos",
    "insights": "Insights",
    "noInsights": "Nenhum insight ainda",
    "completeFirstPlan": "Complete seu primeiro plano",
    "noCheckIns": "Nenhum check-in ainda",
    "startFirstCheckIn": "Faça seu primeiro check-in"
  },
  "support": {
    "title": "Apoio",
    "subtitle": "Encontre respostas, contacte-nos ou comunique um problema",
    "backToSettings": "Voltar às definições",
    "privacyBanner": "Support requests are handled privately and securely. Your health information stays confidential.",
    "section1": "Section 1",
    "section2": "Section 2",
    "section3": "Section 3",
    "section4": "Section 4",
    "navHelpCenter": "Help Center",
    "navContact": "Contact Support",
    "navHealth": "Health Services",
    "navTechnical": "Technical Support",
    "helpCenterTitle": "Help Center",
    "helpCenterSubtitle": "Search common questions and find quick answers.",
    "contactTitle": "Contact Support",
    "contactSubtitle": "Reach our team through your preferred channel.",
    "healthServicesTitle": "Health Services",
    "healthServicesSubtitle": "Connect with medication tracking and clinical experts.",
    "technicalTitle": "Technical Support",
    "technicalSubtitle": "Report bugs or technical issues with detailed context.",
    "searchPlaceholder": "Search common questions…",
    "liveChat": "Live Chat",
    "emailUs": "Email Us",
    "callBack": "Schedule a callback",
    "sendMessage": "Send a message",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "Your name",
    "yourEmail": "Your email",
    "subject": "Subject",
    "message": "Message",
    "phone": "Phone",
    "description": "Description",
    "submit": "Submit",
    "successTitle": "Message sent",
    "successDescription": "We'll reply within 24–48 hours.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "Nutrição Inteligente",
    "basedOnGoal": "Baseado no seu objetivo:",
    "personalizedData": "Personalizado com base em seus dados de saúde recentes",
    "evidenceBased": "Nutrição baseada em evidências como parte do seu plano de saúde preventiva",
    "todaysMealSuggestions": "Sugestões de Refeições de Hoje",
    "customize": "Personalizar",
    "breakfast": "Café da Manhã",
    "lunch": "Almoço",
    "dinner": "Jantar",
    "loadingBreakfast": "Carregando café da manhã...",
    "loadingLunch": "Carregando almoço...",
    "loadingDinner": "Carregando jantar...",
    "cal": "cal",
    "protein": "proteína",
    "swapMeal": "Trocar Refeição",
    "healthyOptionsNearYou": "Opções Saudáveis Perto de Você",
    "enableLocation": "Ativar localização",
    "view": "Ver",
    "discoverOptions": "Descubra restaurantes saudáveis, supermercados e fornecedores de refeições perto de você",
    "cuisinesSelected": "cozinhas selecionadas",
    "cuisineSelected": "cozinha selecionada",
    "dietaryPrefs": "preferências alimentares",
    "dietaryPref": "preferência alimentar",
    "customizeMeals": "Personalize as refeições para corresponder às suas preferências culturais e necessidades dietéticas",
    "subtitleAdaptive": "Culturally adaptive, personalized meal planning for your health goals",
    "hideFavorites": "Hide Favorites",
    "viewFavorites": "View Favorites",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "Ver Plano Completo",
    "exploreRecipes": "Explorar Receitas"
  },
  "location": {
    "permissionTitle": "Encontre opções saudáveis perto de você",
    "permissionDesc": "Usado para recomendar restaurantes, supermercados e fornecedores de refeições alinhados com seus objetivos de saúde.",
    "howToEnable": "Como habilitar:",
    "step1": "Clique no ícone de cadeado 🔒 na barra de endereços",
    "step2": "Encontre permissões de \"Localização\"",
    "step3": "Mude para \"Permitir\"",
    "step4": "Atualize esta página",
    "refreshPage": "Atualizar Página",
    "allowLocation": "Permitir Localização",
    "notNow": "Agora não",
    "denied": "O acesso à localização foi bloqueado. Para ver opções saudáveis próximas, você precisará habilitar as permissões de localização.",
    "unavailable": "As informações de localização não estão disponíveis no momento. Por favor, verifique as configurações do seu dispositivo.",
    "error": "Não foi possível acessar sua localização. Por favor, tente novamente ou verifique as configurações do navegador.",
    "unsupported": "Seu navegador não suporta serviços de localização. Tente usar um navegador moderno como Chrome, Firefox ou Safari.",
    "accessRequired": "Acesso à Localização Necessário"
  },
  "womensHealth": {
    "title": "Saúde da Mulher",
    "description": "Rastreie seu ciclo, registre sintomas e obtenha dicas de bem-estar personalizadas com base na fase do seu ciclo",
    "cycleTracking": "Rastreamento do Ciclo",
    "symptomLogging": "Registro de Sintomas",
    "phaseInsights": "Insights de Fase",
    "logPeriod": "Registrar Período",
    "logSymptoms": "Registrar Sintomas",
    "insights": "Insights",
    "tips": "Dicas de Saúde",
    "overview": "Visão Geral",
    "history": "Histórico",
    "startTracking": "Comece a Rastrear seu Ciclo"
  },
  "profile": {
    "title": "Perfil",
    "personalInfo": "Informações Pessoais",
    "healthProfile": "Perfil de Saúde",
    "preferences": "Preferências",
    "language": "Idioma",
    "selectLanguage": "Selecionar Idioma",
    "notifications": "Notificações",
    "privacy": "Privacidade",
    "security": "Segurança",
    "quickAccess": "Acesso Rápido",
    "editProfile": "Editar perfil",
    "viewStats": "Ver Estatísticas",
    "backToDashboard": "Voltar ao painel",
    "womensHealthTitle": "Women's Health",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Health Reminders",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "Support & Help",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "Give Feedback",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "Report a Problem",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "Basic Information",
    "fullName": "Full Name",
    "email": "Email",
    "dateOfBirth": "Date of Birth",
    "gender": "Gender",
    "height": "Height (cm)",
    "weight": "Weight (kg)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Configurações",
    "general": "Geral",
    "account": "Conta",
    "appearance": "Aparência",
    "languageSettings": "Configurações de Idioma",
    "changeLanguage": "Mudar Idioma",
    "languageNote": "A interface é atualizada no momento em que você seleciona um novo idioma. Os idiomas africanos e os recém-adicionados são marcados como 'Iniciais' — traduzidos automaticamente para maior alcance, aguardando revisão de falantes nativos.",
    "languageUpdated": "Idioma atualizado com sucesso",
    "starterBadge": "Inicial",
    "starterBadgeTooltip": "Tradução automática — revisão por falante nativo pendente.",
    "regions": {
      "global": "Global",
      "european": "Idiomas Europeus",
      "middleEastern": "Idiomas do Oriente Médio",
      "asian": "Idiomas Asiáticos",
      "african": "Idiomas Africanos"
    }
  },
  "search": {
    "triggerLabel": "Buscar no HealthLoop",
    "triggerHint": "Tente \"passos\", \"farmácia\" ou \"gravidez\"",
    "triggerAriaLabel": "Abrir busca global",
    "placeholder": "Buscar recursos, registros, suporte...",
    "inputAriaLabel": "Buscar recursos no HealthLoop",
    "modalAriaLabel": "Busca HealthLoop",
    "close": "Fechar",
    "clear": "Limpar",
    "clearAriaLabel": "Limpar busca",
    "recentSearches": "Buscas recentes",
    "tryFor": "Tente buscar por",
    "findFeatures": "Encontre qualquer recurso em segundos.",
    "searchAcross": "Buscar em",
    "and": "e",
    "sections": {
      "home": "Início",
      "nutrition": "Nutrição",
      "family": "Família",
      "services": "Serviços",
      "support": "Suporte",
      "profile": "Perfil"
    },
    "noMatchesFor": "Nenhum resultado para \"{{query}}\"",
    "trySimpler": "Tente uma palavra mais simples como passos, nutrição ou especialista.",
    "comingSoonBadge": "Em breve",
    "escToClose": "para fechar",
    "resultSingular": "{{count}} resultado",
    "resultPlural": "{{count}} resultados",
    "searchAcrossApp": "Buscar em todo o aplicativo"
  },
  "familyMember": {
    "confirmRemove": "Remover {{name}} do acompanhamento de saúde da família?",
    "removed": "{{name}} removido(a) da família",
    "removeFailed": "Falha ao remover membro",
    "viewDetails": "Ver Detalhes",
    "edit": "Editar",
    "remove": "Remover",
    "yearsSuffix": "anos",
    "healthGoalsLabel": "Metas de Saúde:",
    "moreSuffix": "mais",
    "activeInsights": "Dicas Ativas",
    "viewAllInsights": "Ver todas as {{count}} dicas →",
    "viewFullProfile": "Ver Perfil de Saúde Completo",
    "lifeStage": {
      "infant": "Bebê (0-2)",
      "toddler": "Criança pequena (2-5)",
      "child": "Criança (6-12)",
      "adolescent": "Adolescente (13-17)",
      "adult": "Adulto (18-59)",
      "senior": "Sênior (60+)",
      "unknown": "Não informado"
    }
  },
  "profileDeep": {
    "backToDashboard": "Voltar ao painel",
    "profileCompletion": "Perfil completo",
    "healthSummary": "Resumo de saúde",
    "sectionA": "Secção A",
    "sectionB": "Secção B",
    "sectionC": "Secção C",
    "sectionD": "Secção D",
    "personalDetails": "Dados pessoais",
    "healthInformation": "Informação de saúde",
    "accountSettings": "Definições da conta",
    "fullName": "Nome completo",
    "email": "E-mail",
    "dob": "Data de nascimento",
    "gender": "Género",
    "genderPlaceholder": "ex.: Feminino, Masculino, Não-binário",
    "height": "Altura (cm)",
    "heightPlaceholder": "ex.: 170",
    "weight": "Peso (kg)",
    "weightPlaceholder": "ex.: 70",
    "allergies": "Alergias",
    "allergiesPlaceholder": "ex.: Amendoim",
    "medicalConditions": "Condições médicas",
    "conditionsPlaceholder": "ex.: Hipertensão",
    "medications": "Medicamentos",
    "medicationsPlaceholder": "ex.: Lisinopril 10 mg, diário",
    "emergencyContact": "Contacto de emergência",
    "emergencyOptional": "(opcional)",
    "emergencyPlaceholder": "ex.: Mãe +351 912 000 000",
    "emergencyNote": "Incluído apenas em partilha clínica se aceitar.",
    "saveChanges": "Guardar alterações",
    "saving": "A guardar…",
    "editProfile": "Editar perfil",
    "cancelEditing": "Cancelar edição",
    "healthScore": "Pontuação de saúde",
    "streak": "Sequência",
    "streakDays": "{{n}} dias",
    "memberSince": "Membro desde",
    "remindersActive": "Lembretes ativos",
    "conditionsTracked": "Condições registadas",
    "nextAgenda": "A seguir na sua agenda",
    "notificationsReminders": "Notificações e lembretes",
    "notificationsRemindersDesc": "Gerir horários e canais de lembrete",
    "emailNudges": "Alertas por e-mail",
    "emailNudgesDesc": "Lembretes suaves e resumos semanais",
    "on": "Ativo",
    "paused": "Em pausa",
    "privacySecurity": "Privacidade e segurança",
    "privacySecurityDesc": "Atualize a palavra-passe para proteger a conta",
    "preferencesTitle": "Preferências",
    "preferencesDesc": "Idioma, região e personalização",
    "supportHelp": "Ajuda e apoio",
    "supportHelpDesc": "Obtenha respostas e fale connosco",
    "giveFeedback": "Enviar comentários",
    "giveFeedbackDesc": "Diga-nos o que melhorar",
    "reportProblem": "Comunicar problema",
    "reportProblemDesc": "Encontrou um erro? Diga-nos",
    "adminInsights": "Estatísticas admin",
    "adminInsightsDesc": "Análise de envolvimento",
    "adminBadge": "Admin",
    "shareWithClinician": "Partilhar com um clínico",
    "shareWithClinicianDesc": "Resumo de leitura · expira automaticamente · revogável a qualquer momento",
    "share": "Partilhar",
    "profileMayBeOutOfDate": "O perfil pode estar desatualizado",
    "profileMayBeOutOfDateDesc": "Mantenha os dados atuais para melhores sugestões — pequenas mudanças (peso, medicamentos) ajudam-nos.",
    "updateNow": "Atualizar agora",
    "profileUpdateError": "Não foi possível atualizar. Tente novamente.",
    "healthLoopUser": "Utilizador HealthLoop",
    "updatedLabel": "Atualizado",
    "noEntries": "Ainda sem entradas.",
    "completionComplete": "O seu perfil está completo. Podemos dar a melhor orientação. 💚",
    "completionAlmostThere": "Quase lá. Mais alguns detalhes desbloqueiam sugestões mais precisas.",
    "completionInProgress": "Complete o perfil para receber melhores sugestões de bem-estar.",
    "justNow": "agora mesmo",
    "minAgo": "há {{n}} min",
    "minsAgo": "há {{n}} min",
    "hourAgo": "há {{n}} hora",
    "hoursAgo": "há {{n}} horas",
    "dayAgo": "há {{n}} dia",
    "daysAgo": "há {{n}} dias",
    "checkinDueToday": "Check-in pendente hoje",
    "checkinDueTonight": "Check-in pendente esta noite"
  },
  "supportDeep": {
    "backToSettings": "Voltar às definições",
    "quickNavAria": "Secções de apoio",
    "searchPlaceholder": "Procurar ajuda…",
    "searchAria": "Procurar nas perguntas frequentes",
    "resultsCount": "{{n}} resultado",
    "resultsCountPlural": "{{n}} resultados",
    "questionsCount": "{{n}} perguntas",
    "liveChatTitle": "Conversa em direto",
    "liveChatDesc": "Fale connosco em tempo real · Seg–Sex 9h–18h",
    "startChat": "Iniciar conversa",
    "liveChatSoonToast": "A conversa em direto chega em breve. Por agora, o e-mail funciona bem.",
    "emailUsTitle": "Escreva-nos",
    "emailUsDesc": "Resposta em 24–48 horas",
    "copy": "Copiar",
    "emailCopied": "E-mail copiado.",
    "contactFormTitle": "Formulário de contacto",
    "contactFormDesc": "Envie-nos uma mensagem — respondemos por e-mail.",
    "yourNameLabel": "O seu nome *",
    "namePlaceholder": "Ana Costa",
    "yourEmailLabel": "O seu e-mail *",
    "emailPlaceholder": "ana@exemplo.com",
    "subjectOptional": "Assunto (opcional)",
    "subjectPlaceholder": "Como podemos ajudar?",
    "messageLabel": "Mensagem *",
    "messagePlaceholder": "Descreva brevemente o que precisa.",
    "sending": "A enviar…",
    "sendMessage": "Enviar mensagem",
    "messageSent": "Mensagem enviada",
    "messageSentDesc": "Respondemos em 24–48 horas.",
    "callbackTitle": "Pedir contacto",
    "callbackDesc": "Ligamos quando lhe der jeito.",
    "phoneLabel": "Telefone *",
    "phonePlaceholder": "+351 912 000 000",
    "preferredTimeLabel": "Horário preferido (opcional)",
    "preferredTimePlaceholder": "ex.: amanhã à tarde",
    "reasonLabel": "Motivo (opcional)",
    "reasonPlaceholder": "Em poucas palavras, sobre o que quer falar?",
    "submitting": "A enviar…",
    "requestCallback": "Pedir contacto",
    "callbackRequested": "Pedido de contacto recebido",
    "callbackRequestedDesc": "Falamos consigo em 24 horas.",
    "medicationSupport": "Apoio aos medicamentos",
    "medicationSupportDesc": "Acompanhe receitas, renovações e lembretes.",
    "goToMedications": "Ir para medicamentos →",
    "specialistConsultation": "Consulta com especialista",
    "specialistConsultationDesc": "Fale com um clínico para orientação personalizada.",
    "connectExpert": "Falar com especialista →",
    "videoConsult": "Consulta por vídeo",
    "videoConsultDesc": "Marque uma sessão em vídeo com um especialista.",
    "bookConsultation": "Marcar consulta →",
    "premium": "Premium",
    "healthDisclaimer": "O HealthLoop apoia o seu bem-estar — não substitui cuidados médicos urgentes. Em emergência, contacte os serviços locais.",
    "categoryLabel": "Categoria",
    "catBug": "Erro / Bug",
    "catPerformance": "Lentidão",
    "catFeature": "Função não funciona",
    "catUi": "Problema visual",
    "catOther": "Outro",
    "issueTitle": "Título do problema *",
    "issueTitlePlaceholder": "Resumo breve",
    "detailedDescription": "Descrição detalhada *",
    "detailedDescriptionPlaceholder": "O que aconteceu? O que estava a fazer? Passos para reproduzir ajudam-nos muito.",
    "autoAttachNote": "Informação do dispositivo, browser e janela é anexada automaticamente.",
    "submitReport": "Enviar relatório",
    "reportSubmitted": "Relatório enviado",
    "reportSubmittedDesc": "A nossa equipa está a tratar disso.",
    "fillAllFields": "Por favor preencha todos os campos obrigatórios",
    "problemReportSubmittedToast": "Relatório recebido. Vamos investigar e voltar a si.",
    "messageSentToast": "Mensagem enviada. Respondemos em 24–48 horas.",
    "callRequestedToast": "Pedido de chamada recebido. Falamos em 24 horas.",
    "submitFailGeneric": "Falha no envio. Tente novamente ou escreva para {{email}}.",
    "submitFailContact": "Falha no envio. Escreva diretamente para {{email}}."
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "healthProfile": "Perfil de saúde",
    "notifications": "Notificações",
    "familyAccounts": "Contas familiares",
    "settings": "Definições",
    "logout": "Sair",
    "allCaughtUp": "Está tudo em dia.",
    "weekInReview": "A sua semana em revisão",
    "dismissNotification": "Dispensar notificação",
    "dismissWeeklyDigest": "Dispensar resumo semanal",
    "notificationsAria": "Notificações",
    "profileMenuAria": "Abrir menu do perfil",
    "loadingWellness": "A carregar o seu resumo de bem-estar",
    "nextTip": "Próxima dica",
    "todayAtGlance": "Hoje num relance",
    "healthScoreLabel": "Pontuação de saúde",
    "currentStreakLabel": "Sequência atual",
    "todaysProgress": "Progresso de hoje",
    "insightForYou": "Ideia para si",
    "checkMyHealthRisk": "Verificar o meu risco de saúde",
    "quickAccess": "Acesso rápido",
    "familyCare": "Cuidados de família",
    "healthLibrary": "Biblioteca de saúde",
    "myHealthData": "Os meus dados de saúde",
    "askQuestion": "Fazer uma pergunta",
    "dashLoadError": "Não foi possível carregar o painel. Tente novamente.",
    "taskUpdateError": "Não foi possível atualizar. Tente novamente.",
    "perfectDay": "Dia perfeito! 🎉 Sequência estendida.",
    "letsStart": "Vamos começar",
    "yourNextStepToday": "O seu próximo passo hoje",
    "completeDailyCheck": "Faça o seu check-in diário de saúde",
    "startDailyCheck": "Iniciar check-in diário",
    "viewAll": "Ver tudo",
    "graceProtected": "Período de graça ativo",
    "todaysHealthRecommendations": "Recomendações de saúde de hoje",
    "updateViaCheck": "Atualizar via check-in diário",
    "healthInsight": "Ideia de saúde",
    "riskCheckSubtext": "Receba sugestões personalizadas em segundos",
    "foodDiet": "Alimentação",
    "healthScoreNew": "Pontuação de saúde · Novo",
    "letsBuildScore": "Vamos construir a sua pontuação juntos",
    "oneHealthyHabitAtATime": "Um hábito saudável de cada vez.",
    "nextCheck": "Próximo check-in:",
    "todayAt8pm": "hoje às 20h",
    "wellnessTipForYou": "Dica de bem-estar de hoje · Para si",
    "wellnessTipForFactor": "Dica de bem-estar de hoje · Para o seu {{factor}}",
    "logged": "Registado",
    "gotIt": "Percebi 👍",
    "gladToSeeYou": "Que bom vê-lo hoje 💚",
    "takesLessThan60Sec": "Menos de 60 segundos",
    "scoreReadyWhenYou": "Prontos quando estiver",
    "scoreCompleteFirstCheck": "Faça o primeiro check-in para desbloquear sugestões personalizadas.",
    "scoreExcellent": "Excelente",
    "scoreSupportExcellent": "Está num ótimo estado hoje. Continue!",
    "scoreGood": "Bom",
    "scoreSupportGood": "Está a ir bem. Mantenha os seus hábitos saudáveis.",
    "scoreModerate": "Moderado",
    "scoreSupportModerate": "Está a ir bem, mas algumas áreas precisam de atenção.",
    "scoreNeedsAttention": "Precisa de atenção",
    "scoreSupportNeedsAttention": "A sua saúde precisa de atenção hoje. Pequenas mudanças podem ajudar."
  },
  "emailVerify": {
    "bannerWithEmail": "Verifique o seu e-mail ({{email}}) para mantermos a conta segura e enviar os seus lembretes.",
    "bannerNoEmail": "Verifique o seu e-mail para mantermos a conta segura e enviar os seus lembretes.",
    "sending": "A enviar…",
    "resend": "Reenviar e-mail",
    "sentToast": "E-mail de verificação enviado. Verifique a caixa de entrada.",
    "sendFailToast": "Não foi possível enviar. Tente mais tarde."
  },
  "forgotPassword": {
    "title": "Esqueceu a palavra-passe?",
    "subtitle": "Sem stress! Insira o seu e-mail e enviaremos as instruções.",
    "emailLabel": "Endereço de e-mail",
    "emailPlaceholder": "seu.email@exemplo.com",
    "sendResetLink": "Enviar ligação",
    "sending": "A enviar…",
    "backToLogin": "Voltar ao início de sessão",
    "resendLink": "Reenviar e-mail",
    "successTitle": "Verifique o seu e-mail",
    "successBody": "Se existir uma conta para {{email}}, enviámos uma ligação de redefinição.",
    "linkExpires": "A ligação expira em 30 minutos.",
    "successToast": "Verifique o seu e-mail para as instruções",
    "errEmptyEmail": "Insira o seu e-mail",
    "errInvalidEmail": "Insira um e-mail válido",
    "errNetwork": "Não foi possível contactar o servidor. Verifique a sua ligação.",
    "errGeneric": "Não foi possível enviar. Tente novamente ou contacte o suporte."
  },
  "resetPassword": {
    "title": "Definir nova palavra-passe",
    "subtitle": "Crie uma palavra-passe forte para a sua conta",
    "newPasswordLabel": "Nova palavra-passe",
    "newPasswordPlaceholder": "Introduza a nova palavra-passe",
    "confirmPasswordLabel": "Confirmar palavra-passe",
    "confirmPasswordPlaceholder": "Confirme a nova palavra-passe",
    "requirementsHint": "Pelo menos 8 caracteres, com maiúscula, minúscula e número",
    "resetPassword": "Redefinir palavra-passe",
    "resetting": "A redefinir…",
    "successTitle": "Palavra-passe redefinida!",
    "successBody": "Agora pode entrar com a sua nova palavra-passe.",
    "successToast": "Palavra-passe redefinida com sucesso!",
    "goToLogin": "Ir para o início de sessão",
    "invalidLinkTitle": "Ligação inválida",
    "invalidLinkBody": "Esta ligação de redefinição é inválida ou expirou.",
    "requestNewLink": "Pedir nova ligação",
    "showPassword": "Mostrar palavra-passe",
    "hidePassword": "Ocultar palavra-passe",
    "errInvalidLink": "Ligação de redefinição inválida",
    "errMismatch": "As palavras-passe não coincidem",
    "errTooShort": "A palavra-passe deve ter pelo menos 8 caracteres",
    "errExpiredToken": "Esta ligação expirou ou é inválida. Peça uma nova.",
    "errNetwork": "Não foi possível contactar o servidor. Verifique a sua ligação.",
    "errGeneric": "Falha ao redefinir. Tente novamente."
  },
  "tips": {
    "water1": "Beber água nos primeiros 30 minutos após acordar pode melhorar a hidratação e a energia.",
    "water2": "Um copo de água antes de cada refeição é uma forma suave de antecipar a sede.",
    "water3": "Uma rodela de limão ou folhas de hortelã tornam a hidratação um prazer.",
    "meals1": "Uma porção extra de vegetais por dia apoia a saúde intestinal e do coração.",
    "meals2": "Um punhado de nozes ou sementes ao pequeno-almoço estabiliza a sua energia.",
    "meals3": "A fruta inteira supera o sumo — a fibra suaviza a glicemia.",
    "steps1": "Uma caminhada de 10 minutos após as refeições ajuda o corpo a processar açúcares.",
    "steps2": "5 minutos de alongamento de manhã aliviam a tensão e acalmam o dia.",
    "steps3": "Subir escadas uma vez por dia fortalece o coração ao longo das semanas.",
    "sleep1": "Reduzir a luz uma hora antes de dormir prepara o corpo para um sono mais profundo.",
    "sleep2": "Uma hora de despertar consistente — mesmo aos fins de semana — estabiliza o ciclo do sono.",
    "sleep3": "10 minutos de sol matinal regulam naturalmente o seu ritmo de sono.",
    "general1": "Dois minutos de respiração lenta podem reduzir o stress e firmar o foco.",
    "general2": "Note um momento de gratidão hoje — pequenas vitórias mentais também somam.",
    "general3": "Apareceu hoje. Esse é o hábito que torna todos os outros mais fáceis."
  },
  "factors": {
    "hydration": "hidratação",
    "nutrition": "nutrição",
    "movement": "movimento",
    "sleep": "sono"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Falha ao carregar opções de refeição",
    "prefsSaved": "Preferências guardadas! A atualizar refeições...",
    "prefsSaveFail": "Falha ao guardar preferências",
    "newOptionsFail": "Falha ao carregar novas opções",
    "invalidZip": "Introduza um código postal válido de 5 dígitos",
    "noVendorsArea": "Sem fornecedores nesta zona ainda. Estamos a expandir cobertura!",
    "vendorsFetchFail": "Falha ao obter fornecedores",
    "selectVendorFirst": "Selecione primeiro um fornecedor de entrega",
    "removedFromCart": "Removido do carrinho",
    "orderPlaced": "Encomenda realizada com sucesso! 🎉",
    "enterZipFirst": "Introduza o código postal na secção de entrega primeiro",
    "mealNotAvailable": "Esta refeição ainda não está disponível na sua zona",
    "mealUnavailable": "Esta refeição não está disponível em fornecedores próximos",
    "vendorOptionsFail": "Falha ao carregar opções de fornecedor",
    "favoriteSaveFail": "Falha ao guardar favorito",
    "removedFromFavorites": "Removido dos favoritos",
    "favoriteRemoveFail": "Falha ao remover favorito",
    "cartEmpty": "O seu carrinho está vazio",
    "noMealOptions": "Sem opções de refeição disponíveis",
    "loadingOptions": "A carregar opções de refeição...",
    "selectPreferences": "Selecione as suas preferências alimentares",
    "mealBuilder": "Construir refeição",
    "myFavorites": "Os meus favoritos",
    "myFavoriteMeals": "As minhas refeições favoritas",
    "noFavoritesYet": "Ainda sem refeições favoritas!",
    "price": "Preço",
    "delivery": "Entrega",
    "deliveryFee": "Taxa de entrega",
    "distance": "Distância",
    "subtotal": "Subtotal",
    "total": "Total",
    "orderNumber": "Número da encomenda",
    "vendor": "Fornecedor",
    "totalAmount": "Valor total",
    "estimatedDelivery": "Entrega estimada",
    "whyThisMeal": "Porquê esta refeição",
    "selectThisMeal": "Escolher esta refeição",
    "swapMeal": "Trocar refeição",
    "orderThisMeal": "Encomendar esta refeição",
    "notAvailableNearYou": "Indisponível perto de si",
    "tryAdjustingPrefs": "Ajuste as suas preferências alimentares para ver sugestões",
    "myMealPlanSummary": "O meu plano de refeições",
    "saveCompletePlan": "Guardar plano completo",
    "yourFoodPreferences": "As suas preferências alimentares",
    "editPreferences": "Editar preferências",
    "healthyMealDelivery": "Entrega de refeições saudáveis",
    "enableDelivery": "Ativar entrega",
    "enterZipCode": "Introduza o código postal para ver refeições disponíveis",
    "savePreferences": "Guardar preferências",
    "quickAccessSavedMeals": "Acesso rápido às suas refeições guardadas",
    "saveMealsFromBuilder": "Guarde refeições no separador Construir",
    "chooseVendor": "Escolha um fornecedor para encomendar esta refeição",
    "yourCart": "O seu carrinho",
    "addMealsToStart": "Adicione refeições das opções abaixo para começar",
    "orderPlacedDesc": "A sua encomenda saudável foi feita com sucesso",
    "continueShopping": "Continuar a comprar",
    "trackOrder": "Acompanhar encomenda",
    "healthyStoresTitle": "Lojas Saudáveis e Mercados de Bem-Estar Próximos",
    "healthyStoresIntro": "Tipos de lojas culturalmente diversos para buscar em sua região — apenas sugestões, não realizamos entregas.",
    "healthyStoresGuidanceTitle": "Guia de compras saudáveis",
    "healthyStoresDisclaimer": "HealthLoop compartilha apenas inspirações gerais de bem-estar e compras saudáveis — não fornecemos orientações terapêuticas médicas ou dietéticas.",
    "healthyStores": {
      "organic": {
        "type": "Lojas de produtos orgânicos",
        "description": "Produtos frescos, sem agrotóxicos e itens de despensa minimamente processados.",
        "tags": [
          "Alimentos integrais",
          "Produtos frescos"
        ]
      },
      "farmers": {
        "type": "Feiras livres",
        "description": "Frutas e legumes sazonais cultivados localmente e produtos tradicionais direto do produtor.",
        "tags": [
          "Local",
          "Sazonal"
        ]
      },
      "african": {
        "type": "Lojas de produtos africanos",
        "description": "Inhame, banana-da-terra, folhas verdes e itens básicos das regiões Oeste e Leste da África.",
        "tags": [
          "Cultural",
          "Produtos frescos"
        ]
      },
      "caribbean": {
        "type": "Mercados naturais caribenhos",
        "description": "Mandioca, pimentas, frutas tropicais e outros itens essenciais das ilhas.",
        "tags": [
          "Cultural",
          "Alimentos integrais"
        ]
      },
      "asian": {
        "type": "Supermercados de vegetais asiáticos",
        "description": "Bok choy, daikon, raiz de lótus, tofu, ervas frescas e itens pan-asiáticos.",
        "tags": [
          "Cultural",
          "Produtos frescos"
        ]
      },
      "halal": {
        "type": "Mercados de alimentos saudáveis Halal",
        "description": "Proteínas magras com certificação Halal, produtos frescos e temperos tradicionais.",
        "tags": [
          "Halal",
          "Cultural"
        ]
      },
      "mediterranean": {
        "type": "Mercados de alimentos mediterrâneos",
        "description": "Azeite de oliva, leguminosas, ervas frescas, grãos integrais e itens mediterrâneos básicos.",
        "tags": [
          "Cultural",
          "Alimentos integrais"
        ]
      },
      "wellness": {
        "type": "Empórios focados em bem-estar",
        "description": "Alimentos integrais selecionados, opções plant-based e itens de despensa com rótulos limpos.",
        "tags": [
          "Alimentos integrais",
          "Plant-based"
        ]
      }
    },
    "healthyShoppingTips": [
      "Comece pelo perímetro da loja — produtos frescos e proteínas magras geralmente ficam nas laterais.",
      "Priorize alimentos integrais de ingrediente único em vez de itens ultraprocessados.",
      "Escolha produtos locais da estação — costumam ser mais frescos, baratos e nutritivos.",
      "Pergunte aos vendedores sobre a origem e o cultivo — muitos adoram compartilhar essas informações."
    ]
  },
  "messages": {
    "success": "Sucesso!",
    "error": "Erro",
    "saved": "Salvo com sucesso",
    "updated": "Atualizado com sucesso",
    "deleted": "Excluído com sucesso",
    "confirmDelete": "Tem certeza de que deseja excluir isso?",
    "networkError": "Erro de rede. Por favor, tente novamente.",
    "somethingWrong": "Algo deu errado",
    "failedToLoad": "Falha ao carregar o painel",
    "offlineMode": "Modo offline - mostrando dados limitados",
    "locationDenied": "Acesso à localização negado. Verifique as configurações do navegador para habilitar.",
    "locationUnavailable": "Informações de localização indisponíveis",
    "locationTimeout": "Solicitação de localização expirou. Por favor, tente novamente.",
    "locationError": "Não foi possível acessar a localização",
    "locationGranted": "Acesso à localização concedido! Mostrando opções próximas",
    "locationNotSupported": "Serviços de localização não suportados pelo seu navegador",
    "requestingLocation": "Solicitando acesso à localização..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Rastreador de Saúde Preventiva",
    "educationHub": "Centro de Educação",
    "engagementWidget": "Widget de Engajamento",
    "wellnessCheckIn": "Check-In de Bem-Estar",
    "todaysMetrics": "Métricas de Hoje",
    "bloodPressure": "Pressão Arterial",
    "heartRate": "Frequência Cardíaca",
    "weight": "Peso",
    "sleep": "Sono",
    "waterIntake": "Consumo de Água",
    "exercise": "Exercício",
    "logMetric": "Registrar Métrica",
    "viewHistory": "Ver Histórico"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Lembretes de Saúde",
    "subtitle": "Mantenha-se no caminho certo com notificações de saúde personalizadas",
    "breakfast": "Lembrete de Café da Manhã",
    "lunch": "Lembrete de Almoço",
    "dinner": "Lembrete de Jantar",
    "water": "Consumo de Água",
    "movement": "Pausa para Movimento",
    "sleep": "Lembrete de Sono",
    "wellness": "Check-In de Bem-Estar",
    "healthLogging": "Registro de Saúde",
    "annualCheckup": "Check-up Anual",
    "enable": "Habilitar",
    "disable": "Desabilitar",
    "customize": "Personalizar Horário",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "Junte-se ao HealthLoop",
    "subtitle": "Comece hoje a sua jornada de saúde preventiva",
    "fullName": "Nome completo",
    "email": "E-mail",
    "password": "Palavra-passe",
    "confirmPassword": "Confirmar palavra-passe",
    "createAccount": "Criar conta",
    "haveAccount": "Já tem conta?",
    "signIn": "Entrar",
    "creating": "A criar conta...",
    "passwordTooShort": "A palavra-passe deve ter pelo menos 8 caracteres",
    "setupBiometric": "Configurar início biométrico",
    "setupBiometricDesc": "Use a impressão digital, Face ID ou Windows Hello para um início mais rápido e seguro",
    "setupNow": "Configurar agora",
    "skipForNow": "Mais tarde",
    "settingUp": "A configurar...",
    "benefit1": "Sem palavras-passe para memorizar",
    "benefit2": "Mais segurança com biometria",
    "benefit3": "Entre com um toque ou olhar",
    "biometricPrivacy": "Os seus dados biométricos nunca saem do dispositivo",
    "biometricSuccess": "Início biométrico configurado! 🎉",
    "biometricFailed": "Falha ao configurar início biométrico. Pode configurar mais tarde nas definições.",
    "biometricSetupLater": "Pode configurar o início biométrico mais tarde no seu perfil"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
